/** Download a base64-encoded file in the browser. */
export function downloadBase64(filename, contentB64, mimeType) {
  const binary = atob(contentB64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  const blob = new Blob([bytes], {
    type: mimeType || mimeFromFilename(filename)
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

function mimeFromFilename(filename) {
  if (typeof filename !== "string") return "application/octet-stream";
  if (filename.endsWith(".xlsx")) {
    return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  }
  if (filename.endsWith(".pdf")) return "application/pdf";
  return "application/octet-stream";
}
